import Const from '../config/const';
import { log, LOG_LEVELS } from '../../common/config/app_logger';
import { toCamelCase } from '../../common/config/utils';
import { isPrerenderMode } from '../config/util';
import { getBaseSuperProperties, getBaseProfileProperties } from './mixpanel_properties';
import { queueTrackingEvent } from './application';

let eventsQueueOptimove = [];

const eventsWaitingOptimoveInit = ['session began', 'page visit'];

const saveEventToQueueOptimove = (eventName, eventParams) => {
  log(LOG_LEVELS.INFO, 'Optimove', `saving event to queue ${ eventName }, params:`, eventParams);
  eventsQueueOptimove.push({ eventName, params: eventParams });
};

const trackGTMWithSuperProperties = () => {
  const { user: { user } } = window.store.getState();
  const baseSuperProperties = getBaseSuperProperties({ user });
  return baseSuperProperties;
};

const gtmDataLayerPush = (eventName, eventParams) => {
  const { application: { dynamicConfig } } = window.store.getState();
  if (!dynamicConfig?.enableAnalytics) {
    queueTrackingEvent({ trackingFunction: gtmDataLayerPush, eventName, eventProperties: eventParams });
    log(LOG_LEVELS.INFO, 'GTM', `saving event to queue ${ eventName }, params:`, eventParams);
    return;
  }
  window.dataLayer.push({
    event: eventName,
    ...eventParams,
    ...trackGTMWithSuperProperties()
  });
};

export const trackQueuedOptimoveEvents = () => {
  if (eventsQueueOptimove.length === 0) return;
  eventsQueueOptimove.forEach((event) => {
    const { eventName, params } = event;
    gtmDataLayerPush(eventName, params);
  });
  eventsQueueOptimove = [];
};

export const trackGTMEvent = (eventName, eventProperties) => {
  if (isPrerenderMode()) return;
  window.dataLayer = window.dataLayer || [];
  if (isPrerenderMode()) return;
  if ((!window.optimoveSDK || window.optimoveSDK === undefined) && eventsWaitingOptimoveInit.includes(eventName)) {
    saveEventToQueueOptimove(eventName, eventProperties);
  } else {
    const logEventProperties = { ...eventProperties };
    log(LOG_LEVELS.INFO, 'GTM', `track event: ${ eventName }`);
    log(LOG_LEVELS.DEBUG, 'GTM', 'eventProperties', logEventProperties);
    gtmDataLayerPush(eventName, eventProperties);
  }
};

export const trackFirstPurchaseEventGtm = (params) => {
  trackGTMEvent('first purchase', params);
};

export const trackChatEndedEventGTM = (chatType, params) => {
  let chatName = '';
  switch (chatType) {
    case Const.chatType.text:
      chatName = 'chat';
      break;
    case Const.chatType.voice:
      chatName = 'voice';
      break;
    case Const.chatType.video:
      chatName = 'vc';
      break;
    default:
      break;
  }
  const eventName = `${ chatName } ended`;
  const eventProps = {
    ...params,
    ...toCamelCase(getBaseProfileProperties())
  };
  trackGTMEvent(eventName, eventProps);
};

export const trackFirstVisitEventGtm = () => {
  trackGTMEvent('first visit');
};
